import { Component } from '@angular/core';
import { BaseComponent, UtilsMisc } from '@pit/core';
import { IDtoDevice, IDtoMandator } from '@pit/frontend-model';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { PinItTrackFrontendServicesAccessor } from '../../module.core/accessor/implementations/pin.it.track.frontend.services.accessor';

@Component({
    selector: 'pin-it-track-frontend-mandator-assign-dialog',
    templateUrl: './pin.it.track.frontend.mandator.assign.dialog.component.html',
    styleUrls: ['./pin.it.track.frontend.mandator.assign.dialog.component.scss']
})
export class PinItTrackFrontendMandatorAssignDialogComponent extends BaseComponent {

    constructor(private servicesAccessor: PinItTrackFrontendServicesAccessor, private dialogRef: DynamicDialogRef, private dialogConfig: DynamicDialogConfig) {
        super(servicesAccessor.coreServicesAccessor.applicationService);

        this.device = this.dialogConfig.data.device;
    }

    public device: IDtoDevice = null;

    public mandators: IDtoMandator[] = [];

    public selectedMandator: IDtoMandator = null;

    public get canSubmit(): boolean {
        return (UtilsMisc.isNullOrUndefined(this.selectedMandator) === false);
    }

    public async cancelAsync(): Promise<void> {
        this.dialogRef.close();
    }

    public async submitAsync(): Promise<void> {
        if (this.canSubmit === false) {
            return;
        }
        try {
            this.servicesAccessor.eventService.useMethod('busy.on');
            const updatedDevice: IDtoDevice = await this.servicesAccessor.dataServicesAccessor.deviceDataService
                .assignMandatorToDeviceAsync(this.device.deviceId, this.selectedMandator.id, this.servicesAccessor.currentUser?.userName);
            this.dialogRef.close(updatedDevice);
        } catch (error) {
            this.servicesAccessor.eventService.useMethod('error.log', error);
        } finally {
            this.servicesAccessor.eventService.useMethod('busy.off');
        }
    }

    public onSelectMandator(mandator: IDtoMandator): void {
        this.selectedMandator = mandator;
    }

    protected override async doOnAfterViewInitAsync(): Promise<void> {
        await super.doOnAfterViewInitAsync();

        try {
            this.servicesAccessor.eventService.useMethod('busy.on');
            const allMandators: IDtoMandator[] = await this.servicesAccessor.dataServicesAccessor.deviceDataService.getAllMandatorsAsync();
            const currentMandatorId: number = this.device?.mandator?.id;
            if (UtilsMisc.isNullOrUndefined(currentMandatorId) === true) {
                this.mandators = allMandators;
            } else {
                this.mandators = allMandators.filter(m => (m.id !== currentMandatorId));
            }
        } catch (error) {
            this.servicesAccessor.eventService.useMethod('error.log', error);
        } finally {
            this.servicesAccessor.eventService.useMethod('busy.off');
        }
    }

}
